<h2
  mat-dialog-title
  class="fs-3 pb-4">
  {{ data.title }}
</h2>
<mat-dialog-content>
  <p>{{ data.message }}</p>
</mat-dialog-content>
<mat-dialog-actions class="d-flex flex-row gap-2 justify-content-end border-top pt-4">
  <wfs-form-button
    (buttonClicked)="triggerEvent(data.direction === 'ltr' ? 'saveAndClose' : 'cancel')"
    [label]="data.direction === 'ltr' ? data.confirmCloseText : data.denyText"
    [buttonStyle]="data.direction === 'ltr' ? 'info' : 'warning'" />
  <wfs-form-button
    (buttonClicked)="triggerEvent('saveAndContinue')"
    [label]="data.confirmContinueText"
    [buttonStyle]="'primary'" />
  <wfs-form-button
    (buttonClicked)="triggerEvent(data.direction === 'ltr' ? 'cancel' : 'saveAndClose')"
    [label]="data.direction === 'ltr' ? data.denyText : data.confirmCloseText"
    [buttonStyle]="data.direction === 'ltr' ? 'warning' : 'info'" />
</mat-dialog-actions>
